import { useLang } from "@/context/LanguageContext";
import { planetName, nakshatraName } from "@/lib/i18n";

export function PlanetName({ planet, className, ...rest }) {
  const { lang } = useLang();
  return <span className={className} {...rest}>{planetName(planet, lang)}</span>;
}

export function NakshatraName({ name, className, ...rest }) {
  const { lang } = useLang();
  return <span className={className} {...rest}>{nakshatraName(name, lang)}</span>;
}
